module.exports = __webpack_public_path__ + "media/images/countryrect/scotland-e4faec5e845fb15e91736c23cf0e0997.svg";